<template>
    <v-app>
        <nav v-if="isAdminView">
            <v-app-bar app color="light-blue darken-1" dark>
                <v-app-bar-nav-icon @click.stop="showDrawer=!showDrawer"/>
                <v-toolbar-title class="headline text-uppercase">Yodaforex Cloud Authentication</v-toolbar-title>
                <v-spacer/>
                <y-auth-button success-color="green accent-2" v-model="auth"/>
            </v-app-bar>
            <v-navigation-drawer app v-model="showDrawer">
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title class="title">
                            Menu
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list dense nav>
                    <v-list-item :key="item.title" @click="$router.push(item.route)" link v-for="item in navItems">
                        <v-list-item-icon>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-navigation-drawer>
        </nav>

        <v-content class="grey lighten-3">
            <v-container v-if="auth || !isAdminView">
                <router-view/>
            </v-container>
            <v-container v-else>
                <div class="d-flex justify-center">
                    <v-progress-linear indeterminate/>
                </div>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>


	export default {
		name: 'App',
		data() {
			return {
				showDrawer: false,
				auth: false,
				navItems: [
					{title: "Utilisateurs", route: "/admin/users", icon: "mdi-account"},
					{title: "Tokens", route: "/admin/tokens", icon: "mdi-key"},
				]
			}
		},
		computed: {
			isAdminView() {
				return this.$route.path.substr(0, 6) === '/admin';
			}
		}

	};
</script>

